module.exports = __webpack_public_path__ + "static/media/15UN-Habitat15.5a8342df.jpg";